module.exports = __webpack_public_path__ + "img/product_banner_03.4ec0b1ed.jpg";